import type { ICommand } from '../../core/interfaces/Command';
import type { IRemover } from '@/engine/UIPresentation/Interfaces';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';
import * as DT from '@/engine/PlanningAlgorithm/DataTypes';
import type { IBaseViewModel, IMeasurementViewModel } from '@/engine/app/interfaces';
import type { IIndicationAdder } from '../interfaces';

export class SplineIndicationRemoveCommand implements ICommand {
  private readonly _planningAlgorithm: PlanningAlgorithm;

  private readonly _remover: IRemover;

  private readonly _splineViewModel: IMeasurementViewModel;

  private readonly _ptsDescriptor: string;

  private _splineModel: DT.Polyline | undefined;

  private readonly _splineAdder: IIndicationAdder<DT.Polyline>;

  public constructor(
    planningAlgorithm: PlanningAlgorithm,
    remover: IRemover,
    splineAdder: IIndicationAdder<DT.Polyline>,
    viewModel: IBaseViewModel
  ) {
    this._planningAlgorithm = planningAlgorithm;
    this._remover = remover;
    this._splineViewModel = viewModel as IMeasurementViewModel;
    this._splineAdder = splineAdder;
    this._ptsDescriptor = this._splineViewModel.descriptor + '.pts';
  }

  public execute(): Promise<boolean> {
    this._splineModel = this._planningAlgorithm.getValueStrict(this._ptsDescriptor, DT.Polyline);

    this._remover.removeByDescriptor(this._splineViewModel.descriptor, [this._ptsDescriptor]);

    return Promise.resolve(true);
  }

  public undo(): Promise<boolean> {
    if (!this._splineModel) {
      throw new Error('Model for undo is undefined.');
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- //TODO: [chebotarev] fix eslint no-floating-promises
    this._splineAdder.addIndication(this._splineModel, this._splineViewModel);

    return Promise.resolve(false);
  }
}
